@if (duration) {
  <span class="time {{ extraClass }}">
    @if (duration.durationYear) {
      <span class="inline-block">
        {{ duration.durationYear }}
        {{ duration.durationYear | currentNumeric: 'YEAR' | translate }}
      </span>
    }
    @if (duration.durationMonth) {
      <span class="inline-block">
        @if (duration.durationYear) {
          <span>,</span>
        }
        {{ duration.durationMonth }}
        {{ duration.durationMonth | currentNumeric: 'MONTH' | translate }}
      </span>
    } @else {
      @if (duration.durationDays) {
        <span class="inline-block">
          {{ duration.durationDays }}
          {{ duration.durationDays | currentNumeric: 'DAY' | translate }}
        </span>
      } @else {
        @if (duration.durationHours) {
          <span class="inline-block">
            {{ duration.durationHours }}
            {{ duration.durationHours | currentNumeric: 'HOUR' | translate }}
          </span>
        }
      }
    }
  </span>
}
